// Aviso de llamada entrante fuera de la pestaña (D68): notificacion del sistema con el nombre del cliente y el titulo
// de la pestaña que parpadea. Antes, con la Consola en segundo plano, una llamada solo se veia en la isla.

let aviso: Notification | null = null;
let parpadeo: ReturnType<typeof setInterval> | null = null;
let tituloBase = '';

// Llamada sonando: el icono de la pestaña lo muestra mientras la Consola esta en segundo plano (faviconAviso).
let sonando = false;
const subsLlamada = new Set<() => void>();
export const llamadaSonando = () => sonando;
export function alCambiarLlamada(cb: () => void) {
  subsLlamada.add(cb);
  return () => void subsLlamada.delete(cb);
}
const marcaSonando = (v: boolean) => {
  if (sonando === v) return;
  sonando = v;
  subsLlamada.forEach((cb) => cb());
};

export const notificacionesPosibles = () => typeof window !== 'undefined' && 'Notification' in window;
export const permisoNotificaciones = () => (notificacionesPosibles() ? Notification.permission : 'denied');

// Pedir el permiso dentro de un clic (al conectar el telefono o con el boton de los ajustes).
export async function pedirPermisoNotificaciones() {
  if (!notificacionesPosibles() || Notification.permission !== 'default') return permisoNotificaciones();
  try {
    return await Notification.requestPermission();
  } catch {
    return permisoNotificaciones();
  }
}

export function avisarLlamada(quien: string, numero: string) {
  if (typeof document === 'undefined') return;
  const enSegundoPlano = document.hidden || !document.hasFocus();
  marcaSonando(true);
  if (!parpadeo) {
    tituloBase = document.title;
    let alterna = false;
    parpadeo = setInterval(() => {
      alterna = !alterna;
      document.title = alterna ? `Llamada entrante · ${quien || numero}` : tituloBase;
    }, 1000);
  }
  if (!enSegundoPlano || permisoNotificaciones() !== 'granted') return;
  try {
    aviso?.close();
    aviso = new Notification('Llamada entrante', { body: quien ? `${quien} · ${numero}` : numero, tag: 'llamada-entrante', requireInteraction: true });
    aviso.onclick = () => {
      window.focus();
      aviso?.close();
    };
  } catch {
    aviso = null;
  }
}

export function quitarAvisoLlamada() {
  marcaSonando(false);
  if (parpadeo) {
    clearInterval(parpadeo);
    parpadeo = null;
    document.title = tituloBase;
  }
  aviso?.close();
  aviso = null;
}
